import { render } from "./GdprVideoplayer.vue?vue&type=template&id=1ede1014"
import script from "./GdprVideoplayer.vue?vue&type=script&lang=js"
export * from "./GdprVideoplayer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__